
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class HelpTooltip extends Vue {
  @Prop() private text!: string
  @Prop() private iconSize?: number
}
